import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getRedirects, redirectsSelector } from '../feature';

const useRedirects = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, redirectsList, query } = useAppState(redirectsSelector);

  useEffect(() => {
    dispatch(
      getRedirects({
        page: 1,
      }),
    );
  }, []);

  return useMemo(
    () => ({
      redirects: redirectsList?.data,
      pagination: redirectsList?.meta,
      query,
      isLoading,
      error,
    }),
    [redirectsList, isLoading, error, query],
  );
};

export default useRedirects;
